<template>
  <div>
    <e-table-list
      :table-data="this.evaluationInfo.evaluationBusinessConsultList || []"
      :table-label="tableLabel"
    >
    </e-table-list>
  </div>
</template>

<script>
import eTableList from "../../../../components/common/e-table-list.vue";

export default {
  props: {
    evaluationInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tableData: this.evaluationInfo.evaluationBusinessConsultList || [],
      tableLabel: [
        { label: "业务咨询人", param: "businessConsultName", align: "center" },
        { label: "联系方式", param: "businessConsultTel", align: "center" },
        { label: "邮箱", param: "businessConsultEmail", align: "center" },
      ],
    };
  },

  components: { eTableList },

  computed: {},

  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
